import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const TModulTentePage = () => {
  useEffect(() => {
    document.title = 'T-Modül Tente Tamiri - İzmir Tente Tamir | Profesyonel Tamir Hizmeti';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir genelinde profesyonel T-Modül tente tamiri hizmeti. Modüler sistem arızaları, ray mekanizma ve branda değişimi. 0551 372 35 12');
    }
  }, []);

  const otherServices = [
    { title: 'Zip Perde Tente', link: '/hizmetler/zip-perde-tente' },
    { title: 'Kasetli Tente Tamiri', link: '/hizmetler/kasetli-tente' },
    { title: 'Şeffaf Stor Tente', link: '/hizmetler/seffaf-stor-tente' },
    { title: 'Tente Tamiri', link: '/hizmetler/tente-tamiri' }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      {/* Hero Image Section */}
      <div className="w-full h-64 md:h-96 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/8e5480ed3fea7657e3acfe3662b75049.jpg"
          alt="T-Modül Tente"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="pt-12 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <nav className="text-sm text-gray-500 mb-6">
            <Link to="/" className="hover:text-gray-900 cursor-pointer">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/hizmetler" className="hover:text-gray-900 cursor-pointer">Hizmetler</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-900">T-Modül Tente Tamiri</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                T-Modül Tente Tamiri
              </h1>
              
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                T-Modül tente sistemleri, geniş açıklıkları kapatmak için tasarlanmış modüler gölgeleme çözümleridir. Özellikle kafe, restoran ve ticari alanlarda tercih edilen bu sistemler, estetik ve fonksiyonelliği bir arada sunar. İzmir Tente Tamir olarak, T-Modül tente sistemlerinin tüm arızalarına profesyonel çözümler üretiyoruz.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">T-Modül Tente Nedir?</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                T-Modül tente, birden fazla tente ünitesinin yan yana veya arka arkaya monte edilerek geniş alanları kapatabildiği modüler bir sistemdir. Her modül bağımsız olarak açılıp kapatılabilir veya tüm sistem senkronize çalışabilir. Alüminyum taşıyıcı profiller üzerine monte edilen bu sistemler, manuel veya motorlu olarak üretilebilir. Özellikle büyük teraslar, bahçeler ve ticari mekanlar için ideal çözümdür.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">T-Modül Tente Tamiri Hizmetlerimiz</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                T-Modül tente sistemlerinde karşılaşılan sorunlar ve sunduğumuz çözümler:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Ray Mekanizma Arızaları:</strong> Modüllerin hareket ettiği ray sistemindeki sorunları gideriyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Senkronizasyon Sorunları:</strong> Modüllerin eşzamanlı çalışmasındaki aksaklıkları düzeltiyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Branda Değişimi:</strong> Yıpranan veya hasar gören brandaları yenisiyle değiştiriyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Motor ve Kumanda:</strong> Motorlu sistemlerdeki elektriksel ve mekanik arızaları onarıyoruz.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Taşıyıcı Profil Tamiri:</strong> Alüminyum profillerdeki hasar ve bağlantı sorunlarını çözüyoruz.</span>
                </li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Tamir Süreci</h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">1. Sistem Analizi</h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Deneyimli teknisyenlerimiz, T-Modül tente sisteminizi yerinde detaylı olarak inceler. Her modülün çalışması, ray mekanizması, senkronizasyon ve genel yapısal durum kontrol edilir. Arızanın nedeni belirlenerek size rapor edilir.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">2. Çözüm Planı ve Fiyatlandırma</h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                İnceleme sonrasında, yapılması gereken işlemler ve kullanılacak malzemeler hakkında detaylı bilgilendirme yapılır. Şeffaf ve net fiyat teklifi sunulur.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">3. Onarım İşlemi</h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Onayınızın ardından, orijinal veya eşdeğer kalitede yedek parçalar kullanılarak tamir gerçekleştirilir. Modüler yapı göz önünde bulundurularak her ünite ayrı ayrı kontrol edilir.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">4. Test ve Ayarlama</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Tamir sonrasında tüm modüller kapsamlı testlerden geçirilir. Senkronizasyon ayarları yapılır, açılma-kapanma düzgünlüğü kontrol edilir. Sorunsuz çalıştığından emin olunduktan sonra size teslim edilir.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">T-Modül Tente Avantajları</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Geniş Alan Kapasitesi:</strong> Büyük açıklıkları kapatmak için ideal çözümdür.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Modüler Esneklik:</strong> İhtiyaca göre modül sayısı artırılabilir veya azaltılabilir.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Bağımsız Kontrol:</strong> Her modül ayrı ayrı veya hepsi birlikte kontrol edilebilir.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Estetik Görünüm:</strong> Modern ve şık tasarımı ile mekanınıza değer katar.</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700"><strong>Dayanıklılık:</strong> Kaliteli alüminyum profiller ile uzun ömürlü kullanım.</span>
                </li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Bakım Tavsiyeleri</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                T-Modül tente sisteminizin sorunsuz çalışması için düzenli bakım önemlidir:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700">Ray sistemini düzenli olarak temizleyin ve yağlayın</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700">Brandaları mevsimde bir kez yumuşak fırça ile temizleyin</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700">Fırtınalı havalarda tüm modülleri kapalı tutun</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700">Yılda bir kez profesyonel bakım hizmeti alın</span>
                </li>
              </ul>

              <div className="bg-gray-50 rounded-xl p-8 mt-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Hemen Teklif Alın</h2>
                <p className="text-gray-700 mb-6">
                  T-Modül tente tamiriniz için ücretsiz keşif ve fiyat teklifi almak isterseniz bize ulaşın
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="tel:+905513723512"
                    className="px-6 py-3 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    Telefon: 0551 372 35 12
                  </a>
                  <a
                    href={`https://wa.me/905513723512?text=${encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-6 py-3 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    WhatsApp ile Yaz
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-6 sticky top-24">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Diğer Hizmetlerimiz</h3>
                <ul className="space-y-3">
                  {otherServices.map((service, index) => (
                    <li key={index}>
                      <Link
                        to={service.link}
                        className="block p-3 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm font-medium text-gray-900 transition-colors cursor-pointer"
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TModulTentePage;
